import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Get all subscriptions for the current user (fan)
 * Returns active and historical subscriptions with creator details
 * Used in subscription management page
 */
export const getMySubscriptionsRpcContract = rpcContract({
  name: "get-my-subscriptions",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    subscriptions: v.array(
      v.object({
        id: v.string(),
        influencerId: v.string(),
        influencerHandle: v.optional(v.string()),
        influencerName: v.optional(v.string()),
        status: v.picklist(["active", "past_due", "canceled", "unpaid", "trialing", "paused"]),
        monthlyPriceCents: v.number(),
        currentPeriodStart: v.string(),
        currentPeriodEnd: v.string(),
        cancelAtPeriodEnd: v.boolean(),
        canceledAt: v.optional(v.nullable(v.string())),
        currency: v.string(),
      }),
    ),
  }),
});

export type GetMySubscriptionsParams = v.InferOutput<(typeof getMySubscriptionsRpcContract)["paramsSchema"]>;
export type GetMySubscriptionsResult = v.InferOutput<(typeof getMySubscriptionsRpcContract)["resultSchema"]>;
